const responseSuccessInterceptor = (response) =>
  response.config?.returnFullResponse ? response : response.data;

export default responseSuccessInterceptor;
